import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-background-secondary flex justify-center py-12" }
const _hoisted_2 = { class: "w-[70%] flex flex-col items-center sm:items-start sm:flex-row justify-between" }
const _hoisted_3 = { class: "text-center sm:text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-medium" }, "Greenwash Goods", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs w-64" }, " This website is satirical. It's not meant to be taken seriously, and contains AI generated imagery. ", -1)
const _hoisted_6 = { class: "text-xs w-64 mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "inline" }, " Real sustainability and action to protect the planet we share is important. Take some time to ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "find out what you can do to help", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "inline" }, ".", -1)
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-32 mt-8 sm:mt-0 text-center sm:text-left" }
const _hoisted_11 = { class: "flex flex-col text-sm space-y-1.5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-medium mb-2" }, "Learn More", -1)
const _hoisted_13 = { class: "flex flex-col text-sm space-y-1.5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-medium mb-2" }, "Socials", -1)

import CNavlink from "@/components/c-navlink.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, [
            _createVNode(CNavlink, {
              class: "underline decoration-dotted",
              link: "https://www.canada.ca/en/services/environment/weather/climatechange/get-involved.html"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(CNavlink, { to: "about" }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          }),
          _createVNode(CNavlink, { to: "careers" }, {
            default: _withCtx(() => [
              _createTextVNode("Careers")
            ]),
            _: 1
          }),
          _createVNode(CNavlink, { link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ" }, {
            default: _withCtx(() => [
              _createTextVNode("Sustainability Goals")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(CNavlink, { link: "https://x.com/GreenwashGoods" }, {
            default: _withCtx(() => [
              _createTextVNode("Twitter (not X)")
            ]),
            _: 1
          }),
          _createVNode(CNavlink, { link: "https://www.futuremediahubs.com/future-media-hubs/news/are-golden-days-social-media-already-gone" }, {
            default: _withCtx(() => [
              _createTextVNode("Myspace")
            ]),
            _: 1
          }),
          _createVNode(CNavlink, { link: "https://www.youtube.com/watch?v=Sdkwu2FvFfI" }, {
            default: _withCtx(() => [
              _createTextVNode("Vine")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})